<template lang="pug">
.mg-popup(v-if="popup")
  .mg-popup__overlay(@click.self="closePopup")
    component(:is="getActivePopup", 
      :isSuperPrize="isSuperPrize",
      @stopProgress="stopProgress",
      @closePopup="closePopup"
    )
  
</template>

<script>
import getStoreModuleByName from "@mrg_minigames/common/helpers/store/getStoreModuleByName";

import { createNamespacedHelpers } from "vuex";
const mg_global = getStoreModuleByName("global");
const { mapState } = createNamespacedHelpers(mg_global);

import GetPrize from "./blocks/GetPrize.vue";
import NewCard from "./blocks/NewCard.vue";
import NewCardAll from "./blocks/NewCardAll.vue";
import UpgradeCards from "./blocks/UpgradeCards.vue";
export default {
  name: "Popup",

  components: {
    GetPrize,
    NewCard,
  },

  data() {
    return {
      popup_component: {
        exchange_row: UpgradeCards,
        exchange_superprize: UpgradeCards,
        reward_row: GetPrize,
        reward_superprize: GetPrize,
        new_card: NewCard,
        new_card_all: NewCardAll,
      },
    };
  },

  computed: {
    ...mapState(["popup"]),

    getActivePopup() {
      return this.popup_component[this.popup];
    },
    isSuperPrize() {
      return this.popup === "reward_superprize";
    },
  },

  methods: {
    closePopup() {
      this.$store.commit(`${mg_global}/setPopup`, null);
    },

    stopProgress() {
      this.$emit("stopProgress");
    },
  },
};
</script>
